export default {
  Get: {
    PUBLISH_MIJN_VERHUIS: 'getPublishMijnVerhuis',
  },
  Set: {
    MIJNVERHUIS_REQUEST_INFO: 'setMijnverhuisRequestInfo',
    MIJNVERHUIS_ASSIGN_VALUE: 'assignMijnverhuisValue',
    PRIMARY_CONTACT_ASSIGNVALUE: 'assignMijnVerhuisPrimaryContactValue',
    PRIMARY_CONTACT_RESET: 'resetMijnVerhuisPrimaryContactValue',
    SECONDARY_CONTACT_ASSIGNVALUE: 'assignMijnVerhuisSecondaryContactValue',
    SECONDART_CONTACT_RESET: 'resetMijnVerhuisSecondaryContactValue',
    LEAVING_CUSTOMER_ASSIGNVALUE: 'assignMijnVerhuisLeavingCustomerValue',
    LEAVING_CUSTOMER_RESET: 'resetMijnVerhuisLeavingCustomer',
    CONNECTION_ASSIGNVALUE: 'assignMijnVerhuisConnectionValue',
    CONNECTION_RESET: 'resetConnectionValue'
  }
};